/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class Oas30RequestBody extends ExtensibleNode implements IReferenceNode, IOas30MediaTypeParent {
    public $ref : string;

    public description : string;

    public content : any;

    public required : boolean;

    public constructor() {
        super();
        if(this.$ref===undefined) this.$ref = null;
        if(this.description===undefined) this.description = null;
        this.content = <any>({});
        if(this.required===undefined) this.required = null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitRequestBody(this);
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#createMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public createMediaType(name : string) : Oas30MediaType {
        let rval : Oas30MediaType = new Oas30MediaType(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#addMediaType(java.lang.String, io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {string} name
     * @param {Oas30MediaType} mediaType
     */
    public addMediaType(name : string, mediaType : Oas30MediaType) {
        /* put */(this.content[name] = mediaType);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#getMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public getMediaType(name : string) : Oas30MediaType {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.content, name);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#removeMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public removeMediaType(name : string) : Oas30MediaType {
        return /* remove */(map => { let deleted = this.content[name];delete this.content[name];return deleted;})(this.content);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#getMediaTypes()
     * @return {Oas30MediaType[]}
     */
    public getMediaTypes() : Array<Oas30MediaType> {
        let rval : Array<Oas30MediaType> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.content));
        return rval;
    }
}
Oas30RequestBody["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30RequestBody";
Oas30RequestBody["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent"];





import { Oas30MediaType } from './Oas30MediaType';


import { IOas30MediaTypeParent } from './IOas30MediaTypeParent';

